import { useState } from "react";
import { CalendarHeart, Sparkles, MessageCircle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { whatsappLink } from "@/lib/config";

const optionCls =
  "flex items-center gap-3 w-full px-4 py-3 text-sm text-white/90 hover:bg-[#D4AF37]/10 hover:text-[#D4AF37] transition-colors text-left";

export const BookingChoice = ({ onOpenChat }) => {
  const [open, setOpen] = useState(false);
  return (
  <Popover open={open} onOpenChange={setOpen}>
    <PopoverTrigger asChild>
      <button data-testid="hero-book-choice-btn" className="btn-primary-gold">
        <CalendarHeart size={18} strokeWidth={1.5} />
        Marque seu horário aqui
      </button>
    </PopoverTrigger>
    <PopoverContent
      align="start"
      data-testid="hero-book-choice-menu"
      className="w-72 p-0 bg-[#0A0A0A] border border-[#D4AF37]/40 rounded-none text-white"
    >
      <button
        data-testid="book-choice-ai-btn"
        onClick={() => { setOpen(false); onOpenChat(); }}
        className={optionCls}
      >
        <Sparkles size={16} strokeWidth={1.5} className="text-[#D4AF37]" />
        Agendar com a assistente virtual
      </button>
      <div className="h-px bg-[#222]" />
      <a
        data-testid="book-choice-whatsapp-btn"
        href={whatsappLink()}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => setOpen(false)}
        className={optionCls}
      >
        <MessageCircle size={16} strokeWidth={1.5} className="text-[#D4AF37]" />
        Agendar pelo WhatsApp
      </a>
    </PopoverContent>
  </Popover>
  );
};
